export default class Card {
  constructor({ id, name, imageName, quantity = null, defaultQuantity = 0, uuid = null, playedAt = null, possibleValues = [0,1], noHoldBack = false }) {
    this.id = id;
    this.uuid = uuid;
    this.name = name;
    this.imageName = imageName;
    this.quantity = quantity ?? defaultQuantity;
    this.defaultQuantity = defaultQuantity;
    this.isQuantityFixed = quantity != null;
    this.playedAt = playedAt;
    this.possibleValues = possibleValues;
    this.noHoldBack = noHoldBack;
  }

  get isRed() {
    return this.imageName.includes('red-');
  }

  get isBlue() {
    return this.imageName.includes('blue-');
  }

  get isClock() {
    return this.imageName.includes('clock-');
  }

  get displayName() {
    return this.name;
  }
}
